import { render, staticRenderFns } from "./CreativeInfo.vue?vue&type=template&id=5523dcc8"
import script from "./CreativeInfo.vue?vue&type=script&lang=js"
export * from "./CreativeInfo.vue?vue&type=script&lang=js"
import style0 from "./CreativeInfo.vue?vue&type=style&index=0&id=5523dcc8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports